import script from "./FlexContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlexContainer.vue?vue&type=script&setup=true&lang=ts"

import "./FlexContainer.vue?vue&type=style&index=0&id=37343b65&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37343b65"]])

export default __exports__